import ActionType from './action-type'
import * as Actions from './actions'
import {type LatestLocationThreatScores} from './state'

export function requestLatestLocationThreatScores(): Actions.RequestLatestLocationThreatScoresAction {
    return {
        type: ActionType.REQUEST_LATEST_LOCATION_THREAT_SCORES,
    }
}

/**
 * CDS-6008. Clears the loading flag without touching the scores, so a failed
 * fetch stops the consumers spinning and leaves whatever was last received on
 * screen.
 */
export function latestLocationThreatScoresRequestFailed(): Actions.LatestLocationThreatScoresRequestFailedAction {
    return {
        type: ActionType.LATEST_LOCATION_THREAT_SCORES_REQUEST_FAILED,
    }
}

export function receiveLatestLocationThreatScores(
    latestLocationThreatScores: LatestLocationThreatScores,
): Actions.ReceiveLatestLocationThreatScoresAction {
    return {
        type: ActionType.RECEIVE_LATEST_LOCATION_THREAT_SCORES,
        payload: latestLocationThreatScores,
    }
}
